import { foundationTabPanelStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroTabPanelStyles = (context, definition) => css `
  ${foundationTabPanelStyles(context, definition)}
  :host {
    padding: 0;
  }
`;
